import React, { useEffect, useState } from "react";
import Hero1 from "../imgs/hero/hero-image1.png";
import Hero2 from "../imgs/hero/hero-image2.png";
import { useNavigate } from "react-router-dom";
import { ApiRequest } from "../config/ApiService";

const PatronHero = () => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState("");

  useEffect(() => {
    getRaised();
  }, []);

  const getRaised = async () => {
    try {
      let req = await ApiRequest({
        url: "transactions/raised-amount",
        method: "get",
      });

      if (req.status == "success") {
        setAmount(req.data.totalAmount);
      }
    } catch (error) {}
  };

  return (
    <div className="max-w-7xl mx-auto px-1 md:px-6 lg:px-8 flex justify-between items-center relative pt-20 mb-16">
      <img
        src={Hero1}
        className="hidden lg:flex absolute top-24 left-2 left-img"
        height={130}
        width={130}
      />
      <img
        src={Hero2}
        className="hidden lg:flex absolute top-24 right-2 right-img"
        height={130}
        width={130}
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-12 lg:px-16 flex flex-col items-center justify-center space-y-6">
        <h1 className="text-black font-black text-3xl lg:text-6xl text-center">
          Support The Future Of
          <br />
          <span className="font-black text-[#3BF5CA]">
            Skill-Testing & Rewards
          </span>
        </h1>

        <p className="text-center text-gray-700 text-sm lg:text-base hero-txt">
          We believe in rewarding learning, talent, and dedication in the tech
          and creative arts. Your support can make this vision even bigger.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center md:space-x-4 space-y-4 md:space-y-0">
          <a
            href="#support-form"
            className="w-full md:w-auto px-10 py-4 bg-[#3BF5CA] border text-[#052035] border-[#052035]  rounded-md"
          >
            Become A Patron
          </a>
          <button
            onClick={() => navigate("/supporters")}
            className="w-full md:w-auto px-10 py-4 text-[#052035] border border-[#052035] rounded-md"
          >
            See Supporters
          </button>
        </div>

        <div className="w-full">
          <div className="w-full lg:w-auto rounded-lg bg-[#052035] px-5 py-6 flex flex-col md:flex-row items-center justify-between mt-16">
            <div className="px-5 py-2">
              <h1 className="text-white text-center text-md lg:text-lg">
                Already raised
              </h1>
              <h1 className="text-[#3BF5CA] text-center text-3xl lg:text-5xl">
                ₦{amount ? Number(amount).toLocaleString() : "..."}
              </h1>
            </div>

            <div className="px-5 py-2">
              <h1 className="text-white text-center text-md lg:text-lg">
                Target to raise
              </h1>
              <h1 className="text-[#3BF5CA] text-center text-3xl lg:text-5xl">
                ₦10,000,000
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatronHero;
